import { AccountInfo } from "library/hooks/types";
import { formatAmount } from "library/moneyUtils";

const INTEGER_REGEX = /^\d+$/;

export function validateNewCreditLimit(
  newCreditLimit: string,
  {
    isEmpty,
    data,
  }: {
    isEmpty: (value) => boolean;
    data: AccountInfo;
  },
): string | null {
  if (isEmpty(newCreditLimit)) {
    return "Required";
  }

  if (INTEGER_REGEX.test(newCreditLimit) === false) {
    return "Only 0-9 are allowed";
  }

  const { cardMinCreditLimit, creditLimit } = data;
  const currentBalance = Math.ceil(data.currentBalance);
  const numNewCreditLimit = Number(newCreditLimit);
  if (numNewCreditLimit >= creditLimit) {
    return `Must be lower than your current credit limit of ${formatAmount(
      creditLimit,
    )}`;
  }

  if (numNewCreditLimit < cardMinCreditLimit) {
    return `Must not be below the minimum credit limit of ${formatAmount(
      cardMinCreditLimit,
    )}`;
  }

  if (
    numNewCreditLimit < currentBalance &&
    cardMinCreditLimit < currentBalance
  ) {
    return `To reduce your credit limit to ${formatAmount(
      newCreditLimit,
    )}, you must first pay your current balance down to ${formatAmount(
      newCreditLimit,
    )}`;
  }

  return null;
}
